import PropTypes from 'prop-types'

import useTranslations from '../../../i18n/useTranslations'
import MobileFullScreenLayout from '../../layout/MobileFullScreen'

const ShippingSendMobile = ({ children, isLoading, onClose }) => {
  const t = useTranslations()
  return (
    <MobileFullScreenLayout
      title={t('shipping-send-form:title')}
      isLoading={isLoading}
      onClose={onClose}
    >
      {children}
    </MobileFullScreenLayout>
  )
}

ShippingSendMobile.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  onClose: PropTypes.func,
}

export default ShippingSendMobile
